import axios from "axios";
import { BRANDING } from "../../config/branding";

const proyecto = axios.create({
  baseURL: BRANDING.apiUrl || process.env.REACT_APP_API_URL || "http://localhost:3002",
  headers: {
    "Content-Type": "application/json",
  },
});

proyecto.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default proyecto;

